<a
  [routerLink]="isSubMenuLink ? null : link"
  [routerLinkActive]="isSubMenuLink ? '' : 'active'"
  [routerLinkActiveOptions]="{ exact: !isSubMenuLink }"
  [class.active]="isRouterPartOfSubMenu()"
>
  {{ name }}
  <i class="fa" ngClass="{{ iconClass }}"></i>
</a>
